import {
  Page,
  AdminOfferType,
  ApplicationType,
  OfferAnalytics,
} from "@jobintrans/base-ui.types.api"
import { APIService } from "./APIService"

const getOffers = (
  category: string | null,
  subcategory: string | null,
  page?: number,
  size?: number,
) =>
  APIService.get<null, Page<AdminOfferType>>(
    `/admin/offers?category=${category && category !== "all" ? category : ""}&subcategory=${
      subcategory ?? ""
    }&page=${page}&size=${size}`,
  )
const getOffer = (id: string) => APIService.get<null, AdminOfferType>(`/admin/offers/${id}`)
const countApplications = (id: string) =>
  APIService.get<null, number>(`/admin/offers/${id}/applications`)
const getApplications = (id: string, page: number, size?: number) =>
  APIService.get<null, Page<ApplicationType>>(
    `/admin/offers/${id}/applications/list?page=${page}&size=${size ?? 10}`,
  )
const boost = (id: string) => APIService.patch<null, AdminOfferType>(`/admin/offers/${id}/boost`)
const extend = (id: string) => APIService.patch<null, AdminOfferType>(`/admin/offers/${id}/extend`)
const deactivated = (id: string) =>
  APIService.patch<null, AdminOfferType>(`/admin/offers/${id}/deactivated`)
const permanentlyDelete = (id: string) => APIService.delete<null, null>(`/admin/offers/${id}`)
const getAnalytics = (id: string) =>
  APIService.get<null, OfferAnalytics>(`/admin/offers/${id}/analytics`)
const addAd = (id: string, type: string, link?: string) =>
  APIService.post<null, AdminOfferType>(`/admin/offers/${id}/ad?type=${type}&link=${link}`)

export const AdminOffersService = {
  getOffers,
  getOffer,
  countApplications,
  getApplications,
  boost,
  extend,
  addAd,
  deactivated,
  permanentlyDelete,
  getAnalytics,
}
